import React from "react";
import { HeroReuse } from "../../components/common/HeroReuse";
import NewsShelter from "../../components/sections/blog/NewsShelter";
import LatestUpdate from "../../components/common/LatestUpdate";
import blogSectionImg from '../../assets/images/blogSectionImg.png'

const BlogPage = () => {
  return (
    <div 
      id="articals"
      className="flex flex-col items-center justify-center gap-8 sm:gap-16">
      <HeroReuse
        Subtitle="BLOG"
        Title="Your Trusted RegTech Partner, Bringing Expertise Right to You"
        Description="Keep up with our blog. We cover a wide range of topics, including event updates, industry changes, and all aspects of regulatory, corporate, and compliance news."
        imgUrl={blogSectionImg}
      />
      <NewsShelter />
      <div className="w-full py-10">
        <LatestUpdate />
      </div>
    </div>
  );
};

export default BlogPage;
